/* v8 ignore start -- @preserve UI utility used by shadcn components */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
/* v8 ignore stop */
